import { UserGroup } from "admin/types/interfaces/user";
import { SWRConfiguration } from "swr";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

const useGroups = (
  {
    searchQuery,
    includeSystemUsers = false,
    enabled = true,
  }: { searchQuery?: string; includeSystemUsers?: boolean; enabled?: boolean } = {},
  options?: SWRConfiguration
) => {
  const url = enabled
    ? `${VITE_ACCESS_CONTROLLER_API}/user-tags?include_system_users=${includeSystemUsers}${
        searchQuery ? `&q=${searchQuery}` : ""
      }`
    : null;
  return useFetcher<UserGroup[]>(url, options);
};

export default useGroups;
